// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3agyg","insightsList":"newBusinessInsightsMenu_insightsList__1Ser9","active":"newBusinessInsightsMenu_active__2-aJ3"};